import { useEffect, useRef } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { ButtonRefType } from './Btn';
import { BtnModifier } from './Btn';

export function useBtn(
  reference: ButtonRefType | undefined,
  focusOnMount: boolean,
  hiddenText: boolean,
  modifier?: Modifier<BtnModifier>
) {
  const tmpRef = useRef<HTMLButtonElement | HTMLAnchorElement>(null);
  const ref = reference || tmpRef;

  useEffect(() => {
    if (focusOnMount) {
      setTimeout(() => {
        if (ref && ref?.current) {
          ref?.current.focus();
        }
      }, 100);
    }
  }, [focusOnMount, ref]);

  const cssClasses = bem('btn', modifier);

  return {
    ref,
    hideTooltipFromScreenReader: hiddenText,
    cssClasses,
  };
}
